<template>
  <div class="el-menu-main d-print-none">
    <div class="brand">
      <div class="logo">
        <img :src="agencyLogo" :alt="`${agencyName} Logo`" />
      </div>
      <div class="name">{{ agencyName }}</div>
    </div>
    <div class="menu">
      <el-menu
        :ellipsis="false"
        :default-active="menuActiveIndex" mode="horizontal">
        <el-menu-item index="0">
          <CurrencySelect
            :currency="currency"
            @onSelect="handleCurrencySelect"/>  
        </el-menu-item>
        <el-sub-menu index="1">
          <template #title>{{ userName }}</template>
          <el-menu-item index="1-1" :disabled="true">Perfil</el-menu-item>
          <el-menu-item 
            :router="true" 
            index="1-2" 
            route="/logout"
            >
            <IconLogout></IconLogout>
            Cerrar sesión
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>
    <div class="option-memu">
      <el-button @click="drawerShow">
        <IconMenu />
      </el-button>
    </div>
  </div>
</template>

<script setup>
import useNavigationStore from '@/stores/navigation.js'
import IconMenu from '@/components/icons/IconMenu.vue'
import { computed, inject } from 'vue'
import IconLogout from '../icons/IconLogout.vue'
import { useUserStore } from '@/stores/user'
import { useAgencyStore } from '@/stores/agency'
import CurrencySelect from '../CurrencySelect.vue'

const navigation = useNavigationStore()
const user = useUserStore()
const agencyStore = useAgencyStore()
const { $get_image } = inject('$get_image')

const drawerShow = () => {
  navigation.drawer = !navigation.drawer
}

const currency = computed(() => {
  return agencyStore.currency
})

const agencyName = computed(() => {
  return agencyStore.name.length ? agencyStore.name : 'Agencia Kudenix'
})

const agencyLogo = computed(() => {
  return agencyStore.logo.length ? $get_image(agencyStore.logo) : '@/assets/logo/logo-reduccion.png'
})

const userName = computed(() => {
  const string = user.name.length ? user.name : 'Usuario'

  return string.split(' ')[0]
})

const handleCurrencySelect = (currency) => {
  console.log(currency)
  agencyStore.currency = currency
}
</script>
<style lang="scss">
.el-menu-main {
  display: grid;
  grid-template-columns: 120px 1fr 40px;
  align-items: center;
  height: 100%;
  .menu {
    margin-left: auto;
    min-width: 200px;
    align-items: center;
    @media (max-width: 478px) {
      display: flex;
      min-width: auto;
      height: 100%;
    }
  }
  .option-memu {
    display: flex;
    place-items: center;
    button {
      background-color: transparent;
      border: 0;
    }
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 8px;
    .logo {
      display: flex;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }
    }
    .name {
      @media (max-width: 478px) {
        display: none;
      }
    }
  }
}
</style>
